/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_LabelInputs */

const en_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a preset to load`)
};

const fr_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un préréglage à charger`)
};

const de_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung zum Laden aus.`)
};

const it_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset da caricare`)
};

const ru_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку для загрузки.`)
};

const es_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un ajuste preestablecido para cargar`)
};

const zh_cn2_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要加载的预设。`)
};

const ja_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込むプリセットを選択してください`)
};

const hi_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड करने के लिए एक प्रीसेट चुनें`)
};

const pt_pt2_subtitle_export_preset_load_label = /** @type {(inputs: Subtitle_Export_Preset_Load_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma predefinição para carregar.`)
};

/**
* | output |
* | --- |
* | "Select a preset to load" |
*
* @param {Subtitle_Export_Preset_Load_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_label = /** @type {((inputs?: Subtitle_Export_Preset_Load_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_load_label(inputs)
	if (locale === "de") return de_subtitle_export_preset_load_label(inputs)
	if (locale === "it") return it_subtitle_export_preset_load_label(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_load_label(inputs)
	if (locale === "es") return es_subtitle_export_preset_load_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_load_label(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_load_label(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_load_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_load_label(inputs)
	return en_subtitle_export_preset_load_label(inputs)
});